/**
 * Checks if a given end date has expired.
 *
 * The date is considered expired if the current date and time is after
 * 23:59:59 of the provided end date.
 *
 * @param endDate The end date of the license (ISO string or date string).
 * @returns A boolean value.
 */
export function isExpired(endDate: string) {
  const expiry = new Date(endDate).setHours(23, 59, 59);

  return endDate ? expiry < Date.now() : false;
}
